import React from "react";

import sentry from "../services/sentry-facade";

const pipe_error =
  "The addOnClickBehaviour function only (currently) works when there are exactly two '|' delimiters in your string. Your markup has been rendered literally instead.";
const brace_error =
  "The addOnClickBehaviour function only (currently) works when there are [ and ] delimiters inside of your pipe symbols. Your markup has been rendered literally instead.";

function _addOnClickBehaviour(
  translation: string,
  clickFunc: (e: unknown) => void,
  Component: React.ElementType
): React.ReactNode[] {
  const on_click_matcher = /\[(.*)\]/;
  const hasInnerClickMarkup = (elem: string) => !!elem.match(on_click_matcher);
  const getClickCopy = (elem: string) => elem.match(on_click_matcher)?.[1];

  const split_on_outer_markup = translation.split("|");
  const click_location = split_on_outer_markup.findIndex(hasInnerClickMarkup);
  // @ts-expect-error TS2345 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  const click_copy = getClickCopy(split_on_outer_markup[click_location]);

  const jsxed_translation: React.ReactNode[] = [...split_on_outer_markup];
  jsxed_translation[click_location] = (
    <span key="clicker" className="notranslate">
      {" "}
      <Component onClick={clickFunc} href={Component === "a" ? "#" : undefined}>
        {click_copy}
      </Component>
    </span>
  );

  return jsxed_translation;
}

/**
 * Takes a string with a single block of text marked up |[like this]| and replaces
 * that markup with a link <a onClick={clickFunc}>like this</a>.
 *
 * @param translation
 * @param clickFunc
 * @param Component
 * @returns
 */
function addOnClickBehaviour(
  translation: string,
  clickFunc: (e: unknown) => void,
  Component: React.ElementType = "a"
): React.ReactNode[] {
  try {
    const marker_count = translation.split("").filter(e => e === "|").length;
    if (marker_count !== 2) {
      throw new Error(pipe_error);
    }
    const has_inner_markers = /\|\[.*\]\|/.test(translation);
    if (!has_inner_markers) {
      throw new Error(brace_error);
    }

    return _addOnClickBehaviour(translation, clickFunc, Component);
  } catch (e) {
    sentry.captureException(e);
    return [translation];
  }
}

export default addOnClickBehaviour;
